import React, {useState} from 'react';
import {ChatEngine} from "react-chat-engine";
import ChatFeed from "./components/ChatFeed";
import LoginForm from "./components/LoginForm";
import './App.css'

const App = () => {
    if (!localStorage.getItem('username')) {
        return <LoginForm/>
    }
    return (
        <div>
            <ChatEngine
                height='100vh'
                projectID="c61f035d-8795-4560-8e01-a9c1bd8fd94c"
                userName={localStorage.getItem('username')}
                userSecret={localStorage.getItem('password')}
                renderChatFeed={(chatAppProps) => <ChatFeed {...chatAppProps}/>}
            />
        </div>
    );
};

export default App;
